import { render, staticRenderFns } from "./usermessage.vue?vue&type=template&id=29b491e9&scoped=true"
import script from "./usermessage.vue?vue&type=script&lang=js"
export * from "./usermessage.vue?vue&type=script&lang=js"
import style0 from "./usermessage.vue?vue&type=style&index=0&id=29b491e9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b491e9",
  null
  
)

export default component.exports